/**
 * The asset registry: every texture key the game uses, mapped to the SVG
 * string that draws it and the logical size to rasterize at.
 *
 * BootScene iterates this map, so adding a new piece of art is just adding a
 * builder + an entry here — nothing else to wire up.
 */
import { foodTextures } from './builders/foods.ts';
import { coinTextures } from './builders/coins.ts';
import { animalTextures } from './builders/animals.ts';
import { uiTextures } from './builders/ui.ts';
import { GAME_W, GAME_H } from '../game/config.ts';

export interface TextureSpec {
  svg: string;
  /** Logical (1×) width/height; BootScene rasterizes at RENDER_SCALE. */
  w: number;
  h: number;
}

export function buildAllTextures(): Record<string, TextureSpec> {
  return {
    ...uiTextures(GAME_W, GAME_H),
    ...foodTextures(),
    ...coinTextures(),
    ...animalTextures(),
  };
}
